import { compose } from 'recompose';
import { connect } from 'react-redux';

import { getOwnerTypeAndId } from '../../auth/selectors';

export default compose(
  connect(
    (state) => {
      const owner = getOwnerTypeAndId(state);
      return {
        ownerId: owner.id,
        ownerType: owner.type,
      };
    },
  ),
);
